function n(n,t){if(t.length&&void 0!==t.find((function(t){return t===n||"".concat(t)==="".concat(n)})))return!0;return!1}export{n as contains};
